export default "__VITE_ASSET__e_bLmhMN__"